import financialResource from "@/shared/resource/financial";
import { authorizedAxios } from "./authorizedAxios";

export function linkFinancialCardUrl () {
    return authorizedAxios.post(financialResource.getLinkFinancialCardUrl());
}
export function linkFinancialCardMaintenanceUrl () {
    return authorizedAxios.post(financialResource.getLinkCardMaintenanceUrl());
}
export function linkedCardNeedsMaintenance () {
    return authorizedAxios.get(financialResource.getLinkedCardNeedsMaintenance());
}
export function refreshCustomerAccount () {
    return authorizedAxios.post(financialResource.refreshCustomerAccount());
}
export function deleteLinkedCard (userAccountId: number) {
    return authorizedAxios.delete(financialResource.deleteCustomerAccount(userAccountId));
}
export function deleteLinkedLogin (loginId: number) {
    return authorizedAxios.delete(financialResource.deleteCustomerAccountsByLogin(loginId));
}